/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const MegaphoneIcon = /*#__PURE__*/ createSvgIcon(
  'MegaphoneIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M17.5 10.833h-1.666a.806.806 0 01-.594-.24A.807.807 0 0115 10c0-.236.08-.434.24-.594.16-.16.357-.24.594-.24H17.5c.236 0 .434.08.594.24.16.16.24.358.24.594s-.08.434-.24.594a.806.806 0 01-.594.24zM13.834 14a.76.76 0 01.541-.333.86.86 0 01.625.166l1.334 1c.194.14.305.32.333.542A.86.86 0 0116.5 16a.76.76 0 01-.541.333.86.86 0 01-.625-.166l-1.334-1a.761.761 0 01-.333-.542.86.86 0 01.167-.625zm2.5-8.833l-1.334 1a.86.86 0 01-.625.166.76.76 0 01-.541-.333.86.86 0 01-.167-.625.761.761 0 01.333-.542l1.334-1a.86.86 0 01.625-.166A.76.76 0 0116.5 4a.86.86 0 01.167.625.761.761 0 01-.333.542zM4.167 12.5h-.833c-.459 0-.851-.163-1.177-.49a1.605 1.605 0 01-.49-1.177V9.167c0-.459.163-.851.49-1.177.326-.327.718-.49 1.177-.49h3.333l2.896-1.75a.774.774 0 01.844 0c.284.167.427.41.427.73v7.04c0 .32-.143.563-.427.73a.774.774 0 01-.844 0L6.667 12.5h-.833V15c0 .236-.08.434-.24.594a.806.806 0 01-.594.24.806.806 0 01-.593-.24.807.807 0 01-.24-.594v-2.5zm5-.458V7.958L7.125 9.167H3.334v1.666h3.791l2.042 1.209zm2.5.75V7.208c.375.334.677.74.906 1.22.23.478.344 1.003.344 1.572 0 .57-.115 1.094-.344 1.573-.229.48-.531.885-.906 1.219z"
            fill="#1F1F1F"
          />
        </>
      ),
    },
  },
  false
);

export default MegaphoneIcon;
